import axios from 'axios';

const getAPI = axios.create({
  baseURL: 'https://incident.cirt.cm',
  timeout: 240000,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, 
  xsrfCookieName: 'csrftoken', 
  xsrfHeaderName: 'X-CSRFToken', 
});

export default getAPI;
export { getAPI };